import React, { useEffect, useState } from "react";
import "./Jumbotron.css";
import modelJumbotron from "../../assets/jumbotron/model_jumbotron.webp";
import checkIcon from "../../assets/sec_benefit_sc/icon_check.webp";

const Jumbotron = () => {
  const [provinsi, setProvinsi] = useState(0);
  const [soalLatihan, setSoalLatihan] = useState(0);
  const [kepuasan, setKepuasan] = useState(0);

  useEffect(() => {
    const provinsiInterval = setInterval(() => {
      setProvinsi((prev) => {
        if (prev < 38) {
          return prev + 1;
        }
        clearInterval(provinsiInterval);
        return prev;
      });
    }, 50);

    const soalLatihanInterval = setInterval(() => {
      setSoalLatihan((prev) => {
        if (prev < 5000) {
          return prev + 4;
        }
        clearInterval(soalLatihanInterval);
        return prev;
      });
    }, 1);

    const kepuasanInterval = setInterval(() => {
      setKepuasan((prev) => {
        if (prev < 98) {
          return prev + 1;
        }
        clearInterval(kepuasanInterval);
        return prev;
      });
    }, 30);

    return () => {
      clearInterval(provinsiInterval);
      clearInterval(soalLatihanInterval);
      clearInterval(kepuasanInterval);
    };
  }, []);

  return (
    <React.Fragment>
      <div className="container-jumbotron">
        <div className="text-jumbotron">
          <h1 className="title-jumbotron">
            BIMBEL TERPERCAYA <br /> BAGI CALON ABDI NEGARA
          </h1>
          <div className="box-bimbel-tc">
            <span className="list-bimbel-tc">
              <img
                src={checkIcon}
                alt="Les Privat Akpol"
                className="icon-check-jumbotron"
              />
              Lolos Masuk AKPOL
            </span>
            <span className="list-bimbel-tc">
              <img
                src={checkIcon}
                alt="Les Privat Akpol"
                className="icon-check-jumbotron"
              />
              Lolos Masuk Akademi TNI
            </span>
            <span className="list-bimbel-tc">
              <img
                src={checkIcon}
                alt="Les Privat Akpol"
                className="icon-check-jumbotron"
              />
              Lolos Masuk SIPSS & PA PK TNI
            </span>
            <span className="list-bimbel-tc">
              <img
                src={checkIcon}
                alt="Les Privat Akpol"
                className="icon-check-jumbotron"
              />
              Lolos Masuk Bintara
            </span>
            <span className="list-bimbel-tc">
              <img
                src={checkIcon}
                alt="Les Privat Akpol"
                className="icon-check-jumbotron"
              />
              Lolos Masuk Sekolah Kedinasan
            </span>
          </div>
          <p className="desk-jumbotron">
            Bimbel Persiapan Masuk TNI/POLRI maupun Sekolah Kedinasan Tepercaya
            & Lengkap. Program Layanan Yang Tersedia : Akademik, Psikologi, SKD,
            Jasmani, dan Mental Ideologi.
          </p>
          <div className="text-jumbotron">
            <div className="container-counter">
              <div className="box-part-container">
                <h4 className="number-counter">{provinsi}</h4>
                <span className="text-counter">Provinsi</span>
              </div>
              <div className="box-part-container">
                <h4 className="number-counter">
                  {soalLatihan.toLocaleString()}+
                </h4>
                <span className="text-counter">Soal Latihan</span>
              </div>
              <div className="box-part-container">
                <h4 className="number-counter">{kepuasan}%</h4>
                <span className="text-counter">Kepuasan</span>
              </div>
            </div>
          </div>
        </div>
        <img
          src={modelJumbotron}
          alt="Les Privat Masuk TNI Polri"
          className="img-model-jumbotron"
        />
      </div>
    </React.Fragment>
  );
};

export default Jumbotron;
